import { UnsubscribeReason } from "common/types";

import { UnsubscribeReasonOption } from "../types";

export const unsubscribeReasonOptions = (clinicName: string): UnsubscribeReasonOption[] => {
  const reasonToLabel: Record<UnsubscribeReason, string> = {
    [UnsubscribeReason.TooManyNotifications]: "I get too many emails",
    [UnsubscribeReason.NoLongerClient]: `I am no longer a client of ${clinicName}`,
    [UnsubscribeReason.NoLongerHasPets]: "I no longer have my pet(s)",
    [UnsubscribeReason.DoesNotUseStorefront]: "I do not wish to shop on the online store",
    [UnsubscribeReason.Other]: "Other (fill in reason below)",
  };
  return Object.values(UnsubscribeReason).map((reason) => ({
    value: reason,
    label: reasonToLabel[reason],
  }));
};
